module.exports = __webpack_public_path__ + "static/img/jifen.559c813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jifen.png
// module id = 430
// module chunks = 1